import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'numberSuffix' })
export class NumberSuffixPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || value === '') return '';

    const intVal = this.parseToInt(value);
    if (intVal === null) return '';

    const abs = Math.abs(intVal);
    let suffix = '';
    if (abs >= 1_000_000_000)      suffix = 'B';
    else if (abs >= 1_000_000)     suffix = 'M';
    else if (abs >= 1_000)         suffix = 'K';

    const formatted = new Intl.NumberFormat('es-ES', {
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(intVal);

    return suffix ? `${formatted} ${suffix}` : formatted;
  }

  // Convierte string/number a entero sin decimales, manejando “18,340,384.00”, “2.550.360,00”, “30927149”
  private parseToInt(v: any): number | null {
    if (typeof v === 'number') return Math.trunc(v);
    const s = String(v).trim();
    if (!s) return null;

    // 1) corta la parte decimal (último . o ,) si existe
    const lastDot = s.lastIndexOf('.');
    const lastComma = s.lastIndexOf(',');
    const cutAt = Math.max(lastDot, lastComma);
    const integerPart = cutAt >= 0 ? s.slice(0, cutAt) : s;

    // 2) conserva el signo y elimina todo lo que no sea dígito
    const sign = integerPart.trim().startsWith('-') ? -1 : 1;
    const digitsOnly = integerPart.replace(/[^\d]/g, '');
    if (!digitsOnly) return 0;

    return sign * Number(digitsOnly);
  }
}